<template>
  <b-container class="bv-example-row">
    <b-row class="display-flex display-mobile-block">
      <b-col>
        <b-row align-v="center" align-h="center" class="mb-3">
          <b-col>
            <div class="pie-chart-loans">
              <doughnut-chart
                :dataToRender="dataToRender"
              />
              <div class="pie-information">
                <div class="pie-information_title">
                  {{ selectedCompany.name }}
                </div>
                <div class="pie-information_value">
                  {{ formatInnerText(selectedCompany) }}
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="tab-switcher" align-v="center" align-h="center">
          <b-tabs v-model="selectedMode" pills nav-wrapper-class="income-tabs">
            <b-tab :title="$t('views.statistics.byAmount')"></b-tab>
            <b-tab :title="$t('views.statistics.byPercentage')"></b-tab>
          </b-tabs>
        </b-row>
      </b-col>
      <b-col class="centered-column should-be-first-on-mobile">
        <b-row>
          <b-col>
            <div class="doughnut-title">{{$t('views.statistics.investmentsStatuses')}}</div>
            <Select
                :searchable="false"
                v-model="selectedValue"
                :options="selectData.options"
                label=""
                :unselectable="false"
                :placeholder="selectData.placeholder"
            />
            <div class="chart-section-text">
              <div
                v-for="(section, index) in categoriesMap[selectedValue.value]
                  .data"
                :key="index"
                class="text-block"
                :class="{
                  'text-block__selected': section.name === selectedCompany.name,
                }"
                @click="() => (selectedCompany = section)"
              >
                <div
                  class="dot"
                  :style="{ backgroundColor: section.color }"
                ></div>
                <div class="section_text">{{ section.name }}</div>
                <span style="margin-left: 5px" v-if="section.name==='Buyback initiated'"><img id="buyback_initiated" class="help-tooltip" alt="" src="../../../assets/help.svg" v-b-tooltip.hover/>
                <b-tooltip target="buyback_initiated" triggers="hover">{{ $t('views.account.dLate3Tooltip') }}</b-tooltip></span>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DoughnutChart from '../DoughnutChart'
import Select from '../../textfield/SelectField.vue'
import { BContainer, BCol, BRow } from 'bootstrap-vue'

export default {
  name: 'DoughnutChartWithFilterSection',
  components: {
    DoughnutChart,
    BContainer,
    BRow,
    BCol,
    Select
  },
  watch: {
    categories: {
      handler: function (newVal) {
        this.selectData.options = newVal.map(({ categoryName }) => ({
          value: categoryName,
          name: categoryName
        }))
        newVal.forEach((element) => {
          this.categoriesMap[element.categoryName] = element
        })
        if (newVal.length > 0) {
          this.selectedValue = { ...this.selectData.options[0] }
          //   this.dataToRender = newVal.data;
        }
      },
      immediate: true,
      deep: true
    },
    selectedValue: {
      handler: function (newVal) {
        this.selectedCompany = this.categoriesMap[newVal.value].data[0]
        this.sections = this.categoriesMap[newVal.value].data.map(
          ({ name, color }) => ({
            color,
            name
          })
        )
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    dataToRender() {
      return this.categoriesMap[this.selectedValue.value].data.map(
        ({ amount, name, color, percent, totalPercent }) => ({
          value: this.selectedMode ? (this.selectedCompany.name ? percent : totalPercent) : amount,
          name,
          color,
          isSelected: name === this.selectedCompany.name
        })
      )
    }
  },
  data() {
    return {
      categoriesMap: {},
      selectedCompany: {},
      selectedValue: {},
      selectedMode: 0,
      selectData: {
        options: [
          { value: 'A', name: 'Option A (from options prop)' },
          { value: 'B', name: 'Option B (from options prop)' }
        ],
        closeOnSelect: true,
        searchable: false,
        clearOnSelect: false,
        placeholder: 'Please select one of the variants',
        // disabled: true,
        multiple: false,
        label: 'Multiselect Select required'
      },
      sections: []
    }
  },
  props: {
    dataSections: {
      type: Array,
      required: false,
      default: () => []
    },
    categories: {
      type: Array,
      required: false,
      default: () => []
    },
    inPercent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    formatInnerText(section) {
      return this.selectedMode === 1 ? `${section.percent} %` : `€ ${section.amount}`
    }
  }
}
</script>
